import React from 'react';
import OurWorks from '../Components/OurWorks';
const Gallery = () => {
    return (
        

            <OurWorks />

        
    );
};

export default Gallery;
